import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import AuthModal from './modals/AuthModal';
import './DirectLinkAuth.css';

const DirectLinkAuth = ({ children, requireAuth = true }) => {
  const { isAuthenticated, currentUser, loading, refreshUserProfile, updateCurrentUserFromCache } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pageContent, setPageContent] = useState(null);

  console.log('🔐 DirectLinkAuth render:', {
    loading,
    isAuthenticated: isAuthenticated(),
    requireAuth,
    hasChildren: !!children,
    showAuthModal,
    currentUser: !!currentUser
  });

  useEffect(() => {
    console.log('🔐 DirectLinkAuth useEffect:', {
      loading,
      isAuthenticated: isAuthenticated(),
      requireAuth,
      currentUser: !!currentUser
    });

    // Wait for auth to load
    if (loading) return;

    if (requireAuth && !currentUser) {
      // User is not authenticated but trying to access a protected page
      console.log('🔐 DirectLinkAuth: User not authenticated, showing auth modal');
      setShowAuthModal(true);
      // Still set the page content so it renders in the background (blurred)
      setPageContent(children);
    } else {
      // User is authenticated or page doesn't require auth
      console.log('🔐 DirectLinkAuth: User authenticated or no auth required');
      setShowAuthModal(false);
      setPageContent(children);
    }
  }, [currentUser, loading, requireAuth, children]);

  const handleAuthSuccess = async (userData) => {
    try {
      console.log('🔐 DirectLinkAuth: Authentication successful');
      console.log('🔐 DirectLinkAuth: User data:', userData);
      
      // Immediately update currentUser from cache to sync state
      updateCurrentUserFromCache();
      
      // User successfully authenticated, hide modal and show page
      setShowAuthModal(false);
      console.log('🔐 DirectLinkAuth: Modal hidden, user should now see the page content');
    } catch (error) {
      console.error('🔐 DirectLinkAuth: Error in auth success handler:', error);
      // Still hide modal even if there's an error
      setShowAuthModal(false);
    }
  };

  const handleAuthCancel = () => {
    // User cancelled auth, redirect to home
    window.location.href = '/';
  };

  // Don't render anything while auth is loading
  if (loading) {
    return (
      <div className="direct-link-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="direct-link-auth-wrapper">
      {/* Page content - greyed out if auth modal is showing */}
      <div className={`page-content ${showAuthModal ? 'greyed-out' : ''}`}>
        {pageContent}
      </div>

      {/* Auth modal overlay */}
      {showAuthModal && (
        <AuthModal
          isOpen={true}
          onClose={handleAuthCancel}
          onSuccess={handleAuthSuccess}
          title="Welcome to Yesod"
          subtitle="Sign in to continue"
        />
      )}
    </div>
  );
};

export default DirectLinkAuth;
